<template>
    <div class="app-container">
      <!-- 导航栏 -->
      <a-layout-header class="nav-header">
        <div class="container head-box">
          <div class="logo-site head-left">
            <a href="/sgkPage">
              <img src="../../public/logosgk.png" alt="挖数据提供安全、稳定的数据服务" class="logo-img">
            </a>
            
          </div>
          <div class="home-phone h5-none">
            <div>
              <p class="font-weight-bold">{{ pageTitle || '本站查询数据' }}</p>
              <p class="text-red font-weight-bold">{{ pageSubtitle || '不可公开传播' }}</p>
            </div>
          </div>
          <div class="nav-list">
            <a-button type="primary" href="https://qq.qqpqm.top/sgk/help.html" target="_blank">
              常见问题
            </a-button>
          </div>
        </div>
      </a-layout-header>
  
      <!-- 公告栏 -->
      <div class="top-notice h5-none">
        <a-alert type="info" banner>
            <div>
            <div class="notice-content">
              <span class="icon-cast">【公告】：</span>
              <a-carousel autoplay :autoplaySpeed="3000" dots-class="notice-dots">
                <div v-for="(notice, index) in notices" :key="index" lass="notice-slide">
                  <div class="notice-item">{{ notice }}</div>
                </div>
              </a-carousel>

            </div>
            </div>
            
        </a-alert>
      </div>
  
      <!-- 主要内容 -->
      <a-layout-content class="main-content">
        <div class="container">
          <!-- 分类和搜索 -->
          <div class="api-order">
           
            <button style="    border: 1px solid #e6e6e6;
    width: 90px;
    text-align: center;
    line-height: 35px;
    border-radius: 5px;
    float: left;
    margin: 3px 10px 0 0;
    border-color: #3eb5f6;
    background: #3eb5f6;
    color: #fff;
   ">全部</button>
            
            <div class="search-box h5-none">
              <a-input-search
                v-model:value="searchKey"
                placeholder="请输入查询名称"
                enter-button="搜索"
                @search="handleSearch"
              />
            </div>
          </div>
  
          <!-- 服务列表 -->
          <a-row :gutter="[16, 16]" class="service-list">
            <a-col 
            class="service-card"
              v-for="service in filteredServices" 
              :key="service.id"
              :xs="24" :sm="12" :md="7" 
            >
              <a-card hoverable  @click="goToService(service.id)">
                <div style="float: left;">
                  <img :src="service.image" style="width: 50px;"   class="service-image">
                </div>
               

                <div style="    float: right;width: 80%;">
                    <div style="display: flex;flex-direction: column;height: 100%;">
                        <a href="" class="font-weight-bold ellipsis1" :title="service.title" target="_blank"  data-idjs-processed="true">{{service.title}}</a>
                        <a-card-meta :title="service.title">
                        <div>
                        <p class="service-desc">{{ service.description }}</p>
                        <p class="service-price">
                        <span class="price">$ {{ service.price }}</span>
                        </p>
                        </div>
                        </a-card-meta>
                    </div>
                   
                </div>
                
              </a-card>
            </a-col>
          </a-row>
        </div>
      </a-layout-content>
  
      <!-- 页脚 -->
      <a-layout-footer class="footer">
        <div class="container">
          <div class="copyright">
            <a  href="/sgkPage" style="color:#fff">社工库</a>@版权所有: © 2018-2025
          </div>
        </div>
      </a-layout-footer>
  
      <!-- 返回顶部按钮 -->
      <a-back-top />
    </div>
  </template>
  
  <script>
  import { ref, computed,onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { loadSpecialProduct } from '../util/specialProduct';
  
  export default {
    name: 'HomePage',
    setup() {
      const activeTab = ref('all');
      const searchKey = ref('');
      const referralCode = ref('');
      const pageTitle = ref('');
      const pageSubtitle = ref('');
      const router = useRouter();
      
      // 公告数据
      const notices = ref([
        '查询数据需要挖掘并不能实时获取到数据,一般会在30分钟内将数据发到你的邮箱！',
      ]);
      
      // 服务数据
      const services = ref([
        {
          id: 1,
          title: '查询个人开房记录',
          description: '社工库-查询开房记录需要提供身份证号,只能查询最近3年内的酒店入住记录,一般30分钟出结果。',
          price: '20.00',
          image: '/image/logo1.png',
          url: 'https://qq.qqpqm.top/sgk/1.html'
        },
        {
          id: 2,
          title: '移动联通电信机主实名信息查询',
          description: '社工库-目前只支持中国大陆手机号必须移动联通电信三网的手机号,不支持广电手机号,因为数据库后还没的打通,需要一些时间才可以查询。',
          price: '8.00',
          image: '/image/logo2.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 3,
          title: '查询个人名下手机号码',
          description: '需要提供被查询人的身份证号,目前支持电信、移动、联通、广电的电话号码，已经注销的手机号不会显示在查询结果中。',
          price: '5.00',
          image: '/image/logo3.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 4,
          title: '查询手机号码通话记录',
          description: '目前查询通话记录只能查询最近3个月的记录，只支持移动、联通、电信手机号，暂不支持广电手机号',
          price: '8.00',
          image: '/image/logo4.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 5,
          title: '快手号反查手机号码机主信息',
          description: '即知道快手号，查出此号的身份证正面信息。包括姓名，身份证号，身份证地址。',
          price: '5.00',
          image: '/image/logo5.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 6,
          title: '个人户籍查询',
          description: '需要条件：身份证号码个人户籍，即身份证信息。查询结果是身份证正面信息，包括头像，姓名，民族，户籍地址。',
          price: '5.00',
          image: '/image/logo6.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 7,
          title: '个人的全页户籍查询包括家人',
          description: '需要条件：身份证号码户口本全户页，专业名词叫“户口本索引页”，一般简称“全户”。要查全户，需要你提供其中一个家庭成员的身份证号。样板如图所示，出其中之一。社工库-',
          price: '8.00',
          image: '/image/logo7.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 8,
          title: '查询个人婚姻记录婚姻情况',
          description: '查询婚姻记录，需要提供身份证号。目前判断一个人是否已婚或者离婚，以及配偶的信息（姓名和身份证号），查询婚姻记录是最直接的方法。社工库-',
          price: '12.50',
          image: '/image/logo8.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 9,
          title: '公司股东信息查询',
          description: '也可以出股东的信息，只要占股，哪怕是1%，也可以出其身份证资料。',
          price: '15.00',
          image: '/image/logo9.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 10,
          title: '在逃犯罪人员查询',
          description: '查询在逃/犯罪记录，需要提供身份证号。',
          price: '30.00',
          image: '/image/logo10.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 11,
          title: '个人学历信息查询学籍查询',
          description: '学籍查询，提供身份证号码，可查现就读于哪所大学。',
          price: '12.00',
          image: '/image/logo11.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 12,
          title: '通过手机定位查询具体位置',
          description: '手机定位，原理是利用手机号码停留在基站的信息查询其定位。需要你提供手机号码。按次收费。',
          price: '12.00',
          image: '/image/logo12.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 13,
          title: '快递收货地址等信息查询',
          description: '多地址默认出2个快递的最新地址：圆通、邮政。查询时间1-2天，需要提供电话号码。',
          price: '10.00',
          image: '/image/logo13.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 14,
          title: '查询个人人际关系大关联信息',
          description: '想要查询大关联，需要提供他的身份证号。',
          price: '5.00',
          image: '/image/logo14.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 15,
          title: '查个人工作单位+社保余额',
          description: '查工作单位，需要身份证号。默认出工作单位的途径是出社保详单。',
          price: '10.00',
          image: '/image/logo15.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 16,
          title: '模糊找人-通过大概信息找到精准信息',
          description: '模糊找人，即只知道不确定信息，根据已有的信息查找人。',
          price: '8.00',
          image: '/image/logo16.png',
          url: 'https://qq.qqpqm.top/sgk/1.html'
        },
        {
          id: 17,
          title: '个人外卖收货地址查询',
          description: '查询美团外卖和饿了吗地址，需要提供手机号。查询前，请确认此手机号是其常用手机号。内容包括收货地址，下单时间，支付方式。',
          price: '10.00',
          image: '/image/logo17.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 18,
          title: '车辆行驶轨迹查询',
          description: '要查询车辆轨迹，需要提供的信息是车牌号。目前的车辆轨迹默认出市区版本。',
          price: '30.00',
          image: '/image/logo18.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 19,
          title: '个人宽带安装的地址查询',
          description: '想要查宽带地址，需要提供对方身份证号或者手机号码。',
          price: '5.00',
          image: '/image/logo19.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 20,
          title: '个人飞机、动车查询行程记录',
          description: '查询境内的飞机、火车记录，不包含境内飞境外的航班，如果要查国际航班记录，请看下一个项目——出入境记录。',
          price: '15.00',
          image: '/image/logo20.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 21,
          title: '个人出入境信息查询',
          description: '想要查出入境记录，可以查这个，提供身份证号码或者护照号，两者信息互为转换。',
          price: '18.50',
          image: '/image/logo21.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 22,
          title: '人物轨迹查询具体用什么交通工具去什么地方',
          description: '要查人物轨迹，需要提供身份证号。',
          price: '20.00',
          image: '/image/logo22.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 23,
          title: '个人护照查询',
          description: '根据个人护照号查身份证号码，关联户籍其他亲属信息',
          price: '12.50',
          image: '/image/logo23.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 24,
          title: '查询某个人名下所有房产',
          description: '默认是有房都全出。签发单位是不动产登记中心。名下房业务比较特殊，查空不收费，查到后收费。',
          price: '20.00',
          image: '/image/logo24.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 25,
          title: '查询某个人名下所有车辆信息',
          description: '通过车主身份信息查询名下所有车辆信息，提供车主身份证号，可以查其名下车牌和车辆大概情况。',
          price: '8.50',
          image: '/image/logo25.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 26,
          title: '车辆档案查询详情',
          description: '查车档，需要提供这三者之一：车主身份证号，车牌号，车档编号。',
          price: '8.50',
          image: '/image/logo26.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 27,
          title: '通过身份证查询对方银行卡数量+余额',
          description: '案例中有的银行都可以出卡里的余额，除此之外，对公账户也可以出余额',
          price: '7.00',
          image: '/image/logo27.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 28,
          title: '某个银行卡卡号流水详情查询',
          description: '查银行流水，需要提供银行卡号。可查询具体详情',
          price: '7.00',
          image: '/image/logo28.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 29,
          title: '查询微信聊天记录具体内容查小三利器-纯文字版',
          description: '微信聊天记录，可语音转文字，只要在线，直接秒出',
          price: '10.00',
          image: '/image/logo29.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 30,
          title: '未知司法冻结原因查询详情具体情况',
          description: '我们提供专业的司法冻结查询业务，帮助客户快速准确地获取司法冻结信息，并提供详细的查询报告，确保客户的合法权益得到保障。',
          price: '15.00',
          image: '/image/logo30.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 31,
          title: '通过微信号查询对应的手机号',
          description: '通过微信号反查微信绑定的手机号，带历史绑定的手机号，有几个出几个。',
          price: '8.00',
          image: '/image/logo31.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 32,
          title: '人民银行征信查询无需个人授权',
          description: '人民银行详细版征信记录',
          price: '8.00',
          image: '/image/logo32.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 33,
          title: '抖音号反查好友手机号信息或手机号反查抖音号',
          description: '抖音反查，需提供好友抖音号或者手机号',
          price: '8.50',
          image: '/image/logo33.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 34,
          title: '微信转账红包流水记录查询',
          description: '提供微信号进行查询该账号的流水',
          price: '13.50',
          image: '/image/logo34.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 35,
          title: '微信好友提取',
          description: '微信好友提取，需提供对方微信号',
          price: '10.50',
          image: '/image/logo35.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 36,
          title: '人行详细版征信查询',
          description: '提供姓名身份证号即可查询人行详版征信',
          price: '8.00',
          image: '/image/logo36.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 37,
          title: '微信聊天记录查询-带头像和昵称还有对方微信号',
          description: '提供微信号进行查询该号的聊天记录，带头像和昵称还有对方微信号',
          price: '20.50',
          image: '/image/logo37.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 38,
          title: '通过一张照片人脸识别找人',
          description: '提供一张照片，即可查询相似度最高的人的信息',
          price: '10.00',
          image: '/image/logo38.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 39,
          title: '美团饿了么记录查询',
          description: '美团饿了么记录查询，包括下单地址和订单信息',
          price: '8.00',
          image: '/image/logo39.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 40,
          title: '微信号反查实名信息+手机号+绑定银行卡',
          description: '微信号反查实名信息+手机号+绑定银行卡',
          price: '5.00',
          image: '/image/logo40.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 41,
          title: '京东购物记录查询',
          description: '京东购物记录查询，你想要的信息都有',
          price: '5.00',
          image: '/image/logo41.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 42,
          title: '支付宝收款码反查实名信息',
          description: '支付宝收款码反查对方身份信息',
          price: '8.00',
          image: '/image/logo42.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 43,
          title: '社工库-微信反查QQ、手机',
          description: '社工库-通过知道微信号反查QQ号、手机号，带历史绑定的手机号，有几个出几个。',
          price: '5.00',
          image: '/image/logo43.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 44,
          title: '查询医院病例',
          description: '查询医院病例，查询女友有没有做过人流或得过什么性病',
          price: '15.80',
          image: '/image/logo44.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 45,
          title: '查询支付宝账号流水',
          description: '查询支付宝流水，通过支付宝号或者相应的手机号查询流水',
          price: '18.00',
          image: '/image/logo45.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 46,
          title: '社工库-查询微信收款码实名信息',
          description: '社工库-查询微信收款码，通过微信收款码反查相应的实名信息',
          price: '10.00',
          image: '/image/logo46.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 47,
          title: '手机短信内容查询',
          description: '通过一个手机号码，即可查询对应的发送人信息，接收时间，短信内容，接收人',
          price: '10.00',
          image: '/image/logo47.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 48,
          title: '淘宝购物记录查询',
          description: '轻松查询购物历史，包括购买的商品详细信息、交易时间，详细地址',
          price: '5.00',
          image: '/image/logo48.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        {
          id: 49,
          title: 'QQ好友提取',
          description: 'QQ好友提取，需提供要查目标的QQ号或者手机号',
          price: '8.00',
          image: '/image/logo49.png',
          url: 'https://qq.qqpqm.top/sgk/2.html'
        },
        // 添加更多服务...
      ]);
      
      // 过滤服务
      const filteredServices = computed(() =>
        services.value.filter(service => 
            service.title.includes(searchKey.value) || 
            service.description.includes(searchKey.value)
        )
        );

       // 组件挂载时执行初始化
        onMounted(() => {
            init();
        });

        const init = async () => {
            const params = new URLSearchParams(window.location.search);
            referralCode.value = params.get("code");
            const product = await loadSpecialProduct('sgk', {
              title: '本站查询数据',
              detail: '不可公开传播',
            });
            pageTitle.value = product.title || '本站查询数据';
            pageSubtitle.value = product.detail || '不可公开传播';
        };

      // 切换标签
      const handleTabChange = (key) => {
        console.log('Tab changed:', key);
        // 这里可以添加根据标签过滤服务的逻辑
      };
      
      // 搜索
      const handleSearch = (value) => {
        console.log('Search:', value);
      };
      
      // 跳转到服务详情
      const goToService = (id) => {
        console.log(id)
        router.push({ name: `WokerDetail${id}`,query: { code: referralCode.value }  });
      };
      
      return {
        activeTab,
        searchKey,
        pageTitle,
        pageSubtitle,
        notices,
        services,
        filteredServices,
        handleTabChange,
        handleSearch,
        goToService
      };
    }
  };
  </script>
  
  <style scoped>
  .app-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .nav-header {
    background: #fff;
    padding: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  }
  
  .head-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 64px;
  }
  
  .logo-site img {
    width: 168px !important;
    margin-left: 6rem;
  }
  
  .home-phone {
    display: flex;
    width: 100%;
    justify-content:left
  }
  
  .text-red {
    color: #ff4d4f !important;
  }
  
  .top-notice {
    margin-bottom: 16px;
    margin: 20px auto 20px auto;
    width: 1200px;
    display: block;
    position: relative;
    color: red
  }
  .notice-content .icon-cast {
  float: left;
  color: red;
}
.notice-content .icon-cast:before {
  background: url('../../public/notice.png') no-repeat center 1px;
  background-size: 15px;
  animation: blink 1s infinite !important;
  -webkit-animation: blink 1s infinite !important;
  content: '';
  width: 15px;
  height: 18px;
  float: left;
  display: inline-block;
  margin-top:3px;
}
  
  .notice-content {
    display: flex;
    align-items: center;
  }
  .notice-slide {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
  padding-left: 16px;
  background-color: #fffbe6;
}
  
  .main-content {
    background: #FFF;
    width: 1200px;
    margin: 0 auto;
    flex: 1;
    padding: 20px 30px;
  }
  
  .api-order {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  
  .service-card {
    width: 29%;
    margin-right: 1%;
    text-align: left;
    font-size: 16px;
    cursor: pointer;
    background: #fff;
    margin: 0 1% 10px 0;
    float: left;
    padding: 20px 10px;
    position: relative;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
  }
  
  .service-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  .service-image {
    object-fit: contain;
    -webkit-transition: width 1s, height 1s, -webkit-transform 1s;
    transition: width 1s, height 1s, transform 1s;
    animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
    -moz-animation-timing-function: linear;
    -o-animation-timing-function: linear;
  }
  
  .service-desc {
    font-size: 12px;
    margin-bottom: 8px;
    color: #000;
    height: 48px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  .price {
    color: #ff6633 !important;
    font-weight: bold;
  }
  
  .footer {
    text-align: center;
    padding: 16px 0;
    color: #fff;
    background: #1e2123;
    font-size: 14px;
    font-family: '微软雅黑';
  }
  .copyright{
    color: #fff;
  }
  .font-weight-bold{
    margin-block-start:0px;
    margin-block-end:0px;
    color: #000;
    font-weight: 500;
  }

              
  .service-price{
    margin-block-start:0px;
    margin-block-end:0px;
    margin-top: auto;
  }
  
  @media (max-width: 768px) {
    :deep(.ant-col-md-8) {
        display: block;
        flex: 32%;
        max-width: 33.33333333333333%;
    }
    .h5-none {
      display: none;
    }
    
    .head-box {
      padding: 0 12px;
    }
    
    .service-list {
      margin: 0 -8px;
    }
    
    .service-image {
      height: 120px;
    }
  }
  </style>